import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getCruiseSalesInput,
  getCruiseSaleInput,
  CruiseSaleLiteModel,
  CruiseSaleModel,
} from './model';

export function useGetCruiseSales(
  input?: getCruiseSalesInput,
  options?: UseQueryOptions<ExtendedApiResult<CruiseSaleLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<CruiseSaleLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getCruiseSales', input?.params],
      () =>
        QueryFetchFunction({
          url: 'cruise-sales',
          params: input?.params,
        }),
      options,
    ),
    CruiseSaleLiteModel,
  );
}

export function useGetCruiseSale(
  input?: getCruiseSaleInput,
  options?: UseQueryOptions<ApiResult<CruiseSaleModel>, ApiError>,
): UseQueryResult<ApiResult<CruiseSaleModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getCruiseSale', input?.id],
      () => QueryFetchFunction({ url: `cruise-sales/${input?.id}` }),
      options,
    ),
    CruiseSaleModel,
  );
}

export function getCruiseSalesKey(input?: getCruiseSalesInput) {
  return ['getCruiseSales', input?.params];
}

export function getCruiseSaleKey(input?: getCruiseSaleInput) {
  return ['getCruiseSale', input?.id];
}
